import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import {
  BuildIcon,
  DesignIcon,
  LaunchIcon,
  MaintenanceIcon,
  PlaneIcon,
  TestIcon,
} from "../../../app-constants";

function Workflowprocess() {
  return (
    <section
      className="workflow_process cloud_app_process blockchain_software_services p-100"
      style={{ backgroundColor: "#F9F9F9" }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={11}
            lg={10}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              Our Efficient Procedure for Blockchain Software{" "}
              <span>Development Services</span>
            </h2>
            <p>
              The development of blockchain solutions is based on trust, making
              them solid, reliable, and of high scalability. Supplying the
              utmost clarity in every process, we take you through step by step
              and offer the highest quality of service that meets your company’s
              goals. 
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="my-auto">
            <div className="workflow_main">
              <div className="workflow_process_item">
                <div className="workflow_process_img">{PlaneIcon}</div>
                <div className="workflow_process_content">
                  <h5>Requirements Analysis</h5>
                  <p>
                    To start with, we work with stakeholders to get a clear
                    understanding of your business objectives, IT requirements,
                    and project specifications. This phase sets the tone for the
                    specific blockchain solution that best fits your needs and
                    problem statement.
                  </p>
                </div>
              </div>
              <div className="workflow_process_item">
                <div className="workflow_process_img">{DesignIcon}</div>
                <div className="workflow_process_content">
                  <h5>Technical Feasibility and Design</h5>
                  <p>
                    The second step is to conduct the technical viability
                    assessment that will identify the most suitable blockchain
                    for your project as well as the technological solution. Our
                    architects then create a plan with the system structure,
                    data inputs/outputs, and interfaces to achieve high
                    efficiency and expansibility.
                  </p>
                </div>
              </div>
              <div className="workflow_process_item">
                <div className="workflow_process_img">{BuildIcon}</div>
                <div className="workflow_process_content">
                  <h5>Prototyping</h5>
                  <p>
                    During the prototyping phase, the MVP is built to test the
                    main relevant features of the blockchain app. It enables us
                    to receive the primary stakeholder’s feedback and adjust
                    features and the overall solution to comply with their
                    expectations before large-scale development.
                  </p>
                </div>
              </div>
              <div className="workflow_process_item">
                <div className="workflow_process_img">{TestIcon}</div>
                <div className="workflow_process_content">
                  <h5>Development</h5>
                  <p>
                    To create the blockchain application, we use agile
                    methodologies in the development team for integration and
                    delivery. Thus, we follow the standard coding techniques of
                    today’s programming language to produce secure and clean
                    code and subsequently a high-standard product.
                  </p>
                </div>
              </div>
              <div className="workflow_process_item">
                <div className="workflow_process_img">{LaunchIcon}</div>
                <div className="workflow_process_content">
                  <h5>Testing and Quality Assurance</h5>
                  <p>
                    Testing on the application and quality control are essential
                    in our endeavor. To minimize these incidents, we perform
                    rigorous unit, integration, and system testing. The QA team
                    guarantees that the application is optimized in terms of
                    performance, security, and compliance before release.
                  </p>
                </div>
              </div>
              <div className="workflow_process_item">
                <div className="workflow_process_img">{MaintenanceIcon}</div>
                <div className="workflow_process_content">
                  <h5>Deployment and Maintenance</h5>
                  <p>
                    After testing, we integrate the blockchain app into a live
                    environment, thus stabilizing it and such changes can cause
                    minimal disruption. After that, we have to ensure continuous
                    evaluation, upgrades, and troubleshooting as well as provide
                    necessary upkeep to guarantee the system’s effectiveness in
                    the long run.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Workflowprocess;
